module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-14.1c47ec49.png";